import { ENodeInputTypeCode, ENodeOutputTypeCode } from '@shared/typings/flow/common/data';
import { NodeType } from '@shared/utils/build/flow/position';

//获取节点的大小
export const getSize = (types: NodeType) => {
	switch (types) {
		case ENodeInputTypeCode.Text:
			return { width: 100, height: 40 };
		case ENodeInputTypeCode.Image:
			return { width: 100, height: 40 };
		case ENodeOutputTypeCode.Canvas:
		case ENodeOutputTypeCode.Image:
		case ENodeOutputTypeCode.Text:
		case ENodeOutputTypeCode.Video:
		case ENodeOutputTypeCode.LongVideo:
			return { width: 160, height: 248 };
		default:
			return { width: 150, height: 40 };
	}
};
